import { render, staticRenderFns } from "./statistique.vue?vue&type=template&id=1d20fbd3"
import script from "./statistique.vue?vue&type=script&lang=js"
export * from "./statistique.vue?vue&type=script&lang=js"
import style0 from "./statistique.vue?vue&type=style&index=0&id=1d20fbd3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports